import { BIBME, CHEGG, CITATION_MACHINE, EASYBIB } from '@src/state/site/types'

export const siteToProductCode = {
  [EASYBIB]: 'EASYBIB',
  [CHEGG]: 'CHEGG_WRITING',
  [CITATION_MACHINE]: 'CITATIONMACHINE',
  [BIBME]: 'BIBME',
}

export const siteToPlanCode = {
  [EASYBIB]: 'bib1m3dft_base',
  [CHEGG]: 'cw1m3dft_base',
  [CITATION_MACHINE]: 'cm1m3dft_base',
  [BIBME]: 'bm1m3dft_base',
}



// WEBPACK FOOTER //
// ./src/components/Modals/PaymentModal/utils.tsx